import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { shortDateFormat } from "../dateTimeHelpers";

@Pipe({
    name: "utcShortDate",
    standalone: false
})
export class UtcShortDatePipe implements PipeTransform {
  pipe = new DatePipe("en-US");
  transform(value: string | Date | null): string {
    if (value) {
      return this.pipe.transform(value, shortDateFormat, "UTC");
    }
    return null;
  }
}
